import ChicletNav from 'components/Homepage/ChicletNav/ChicletNav';
import { withNavigationMenu } from 'hocs/page/withNavigationMenu';

export default withNavigationMenu(ChicletNav);
